export default function Play() {
  return (
    <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.8111 11.7045C17.0477 11.2187 16.0488 11.767 16.0488 12.6719V35.2497C16.0488 36.1545 17.0477 36.7029 17.8111 36.2171L35.5508 24.9282C36.2589 24.4776 36.2589 23.444 35.5508 22.9934L17.8111 11.7045Z"
        fill="white"
        fillOpacity="0.88"
      />
    </svg>
  )
}
